import './App.css';
import GoogleTranslate from './component/Language/GoogleTranslate';
import Layout from './component/Layout/Layout';
import Home from './pages/Home';

function App() {
  return (
    <Layout>
      <GoogleTranslate/>
       <Home/>
  </Layout>
  );
}

export default App;
